module.exports = __webpack_public_path__ + "static/media/user_avatar.d325de0f.png";